<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit-partnership-activity-mail-recipient-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Edit Recipient
            </h4>
          </div>

          <div class="modal-body">
            <TextFormGroup
                v-model="data.name"
                name="name"
                label="Name"
                :error="(errors.name || [])[0]"
            />

            <TextFormGroup
                v-model="data.email"
                name="email"
                label="Email"
                :error="(errors.email || [])[0]"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {TextFormGroup},

  mixins: [Errors],

  props: {
    partnershipActivityMailRecipient: {
      required: true
    },
  },

  data() {
    return {
      data: {}
    }
  },

  mounted() {
    this.listenForClose()
  },

  watch: {
    partnershipActivityMailRecipient() {
      this.data = {
        ...this.partnershipActivityMailRecipient.attributes,
      }
    }
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.put('/api/v2/partnership-activity-mail-recipients/' + this.partnershipActivityMailRecipient.id, this.data)
          .then(response => {
            notify.success('The recipient was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {
        ...this.partnershipActivityMailRecipient.attributes,
      }
    }
  }
}
</script>
